import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import Search from '../search';
import People from '../peopleList';
import Nav from '../navList';
import { getWyList, searchWyList } from '../../../services/api';
import { getImage } from '../../../utils/cutImg';

/**
 * 定义 委员列表 组件
 */

class SiderBar extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    state = {
        allData: {},
        wyListInfo: [],
        letterList: [],
        navLetter: 'C',
        serchValue: '',
    };
    componentDidMount() {
        this.getWy('');
    }
    getWy = async text => {
        const wyData = await getWyList(text);
        const formatData = [];

        let charList = [];

        wyData.msg =
            wyData.msg && wyData.msg.length > 0
                ? wyData.msg.map(item => {
                      item.feng_url = `//feng.ifeng.com/author/${item.zmt_id}`;
                      item.firstC = this.getUpperAleph(item.spell);
                      item.image = getImage(item.image, 68, 68);
                      formatData.push(item);
                      charList.push(item.firstC);

                      return '';
                  })
                : [];

        charList = Array.from(new Set(charList));
        charList = charList.sort();

        const allForData = this.handlerData(charList, formatData);
        const letter = this.state.navLetter;
        const wyUlData = allForData[letter];

        // console.log('all===', allForData);
        this.setState({
            allData: allForData,
            wyListInfo: wyUlData,
            letterList: charList,
        });
    };
    searchWy = async text => {
        const wyData = await searchWyList(text);
        const formatData = [];

        if (wyData.code === 1) {
            wyData.msg =
                wyData.msg && wyData.msg && wyData.msg.length > 0
                    ? wyData.msg.map(item => {
                          item.feng_url = `//feng.ifeng.com/author/${item.zmt_id}`;
                          item.image = getImage(item.image, 68, 68);
                          formatData.push(item);

                          return '';
                      })
                    : [];
        }

        this.setState({
            wyListInfo: formatData,
        });
    };
    // 按照首字母做分组处理
    handlerData = (chaList, dataList) => {
        let dataCh = [];
        let wyDataF = {};

        chaList.map(item => {
            dataCh = dataList.filter(dataItem => {
                return dataItem.firstC === item;
            });

            wyDataF[item] = dataCh;

            return '';
        });

        return wyDataF;
    };

    getUpperAleph = name => {
        // 获取字符串的首字母并将其大写
        let fN = name.charAt(0);

        fN = fN.toUpperCase();

        return fN;
    };
    changeLetter = letter => {
        this.setState({
            navLetter: letter,
        });
        const wyUlData = this.state.allData[letter];

        this.setState({
            wyListInfo: wyUlData,
        });
    };
    keyDownHandler = e => {
        console.log('ddd==', e);

        if (e !== '') {
            this.searchWy(e);
        }
    };
    clickHandler = text => {
        console.log('click');
        if (text !== '') {
            this.searchWy(text);
        }
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { wyListInfo, letterList, navLetter, serchValue } = this.state;

        return (
            <div className={styles.sideBar}>
                <div className={`${styles.h2wrapper} clearfix`}>
                    <h2>专栏作者</h2>
                    <a href="http://finance.ifeng.com/institute/committee.shtml" target="_blank">
                        MORE&gt;
                    </a>
                </div>
                <Search keyDownHandler={this.keyDownHandler} clickHandler={this.clickHandler} />
                <People content={wyListInfo} />
                <Nav content={letterList} changeLetter={this.changeLetter} letter={this.state.navLetter} />
            </div>
        );
    }
}

SiderBar.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(SiderBar);
